import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import { WorkCard } from '../components/WorkCard';
import { CTASection } from '../components/CTASection';
import { projects, workCategories } from '../data/work';
export function Work() {
  const [filter, setFilter] = useState('All');
  const visible = filter === 'All' ? projects : projects.filter(p => p.category === filter);
  return <>
      <PageHeader eyebrow="Selected work" title="Mandates that changed what a market could do." intro="A selection of engagements across ecosystem design, venture building, capital strategy and corporate innovation." data-id="element-497" data-mp="3vygto2icklyq" />

      <section className="px-6 sm:px-10" data-id="element-498" data-mp="3n3slo4le0q68">
        <div className="mx-auto max-w-[92rem]" data-id="element-499" data-mp="epk55uw53puf">
          <div className="flex flex-wrap gap-2 border-y border-charcoal/[0.08] py-5" data-id="element-500" data-mp="eosduw9kse9y">
            {workCategories.map(c => <button key={c} type="button" onClick={() => setFilter(c)} className={`rounded-full px-4 py-2 text-[0.75rem] uppercase tracking-[0.12em] transition-all duration-500 ${filter === c ? 'bg-charcoal text-ivory' : 'text-charcoal/55 hover:bg-charcoal/[0.05] hover:text-charcoal'}`} data-id="element-501" data-mp="3i9bzk2k4lyx6">
                {c}
              </button>)}
          </div>

          <motion.div layout className="grid gap-16 pb-28 pt-16 md:grid-cols-2 sm:pb-40" data-id="element-502" data-mp="twtkua94dfz">
            {visible.map((p, i) => <Reveal key={p.slug} delay={i % 2 * 0.08} data-id="element-503" data-mp="escyqgsgtvw0" data-mpi={i}>
                <WorkCard project={p} data-id="element-504" data-mp="9ta5ruprfg4e" />
              </Reveal>)}
          </motion.div>
        </div>
      </section>

      <CTASection data-id="element-505" data-mp="2gl15v188d3h2" />
    </>;
}